import SocialLoginButtons from './SocialLoginButtons';

export default SocialLoginButtons;
